
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const getAuthURL= async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(
          `${dev_baseUrl}/QuickBooks/auth-url`,
          {
            method: "GET",
            headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
          }
        );
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
  
      } catch (error) {
        console.error('Network error:', error);
        return { isError: true, message: 'An error occurred. Please try again later.', error: error };
      }
    } else {
      console.warn('Access token is not available.');
      return { isError: true, message: 'Access token is missing.' };
    }
};

export const CallBack= async (code,realmId,state,navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(
          `${dev_baseUrl}/QuickBooks/callback?code=${code}&realmId=${realmId}&state=${state}`,
          {
            method: "POST",
            headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
          }
        );
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
  
      } catch (error) {
        console.error('Network error:', error);
        return { isError: true, message: 'An error occurred. Please try again later.', error: error };
      }
    } else {
      console.warn('Access token is not available.');
      return { isError: true, message: 'Access token is missing.' };
    }
  };

  export const getConnectionStatus = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(
          `${dev_baseUrl}/QuickBooks/connection-status`,
          {
            method: "GET",
            headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
          }
        );
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
      } catch (error) {
        console.error('Network error:', error);
        return { isError: true, message: 'An error occurred. Please try again later.', error: error };
      }
    } else {
      console.warn('Access token is not available.');
      return { isError: true, message: 'Access token is missing.' };
    }
  };

  export const DisconnectConnection = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(
          `${dev_baseUrl}/QuickBooks/disconnect`,
          {
            method: "POST",
            headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
          }
        );
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
      } catch (error) {
        console.error('Network error:', error);
        return { isError: true, message: 'An error occurred. Please try again later.', error: error };
      }
    } else {
      console.warn('Access token is not available.');
      return { isError: true, message: 'Access token is missing.' };
    }
  };